const MFA_SETUP_REQUIRED_KEY = "eternua.mfa.must_setup";
const MFA_SETUP_TOKEN_KEY = "eternua.mfa.setup.token";
const MFA_SETUP_PENDING_KEY = "eternua.mfa.setup.pending";

function storage(name) {
  if (typeof window === "undefined") return null;
  try {
    return window[name];
  } catch (_error) {
    return null;
  }
}

function remove(store, key) {
  try {
    store?.removeItem(key);
  } catch (_error) {
    // Storage can be unavailable in private browsing mode.
  }
}

export function clearPendingMfaSetup() {
  const session = storage("sessionStorage");
  const local = storage("localStorage");

  [session, local].forEach((store) => {
    remove(store, MFA_SETUP_REQUIRED_KEY);
    remove(store, MFA_SETUP_TOKEN_KEY);
    remove(store, MFA_SETUP_PENDING_KEY);
  });
}
